import React, { useEffect, useState } from "react";
import SideBar from "../component/SideBar";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import { HiOutlineShoppingBag } from "react-icons/hi";
import Skeleton from "../component/Skeleton";
import { toast } from "react-toastify";
import { useSettings } from "../context/settingContext";
import { useOrders } from "../context/ordersContext";

const Wishlist = () => {
    const { user } = useSettings();
    const userId = user?.id;
    const [removingId, setRemovingId] = useState(null);
    const { wishItem, setWishItem, getWishItem } = useOrders();

    useEffect(() => {
        if (userId) getWishItem();
    }, [userId]);

    const DeletWishItem = async (prdId) => {
        setRemovingId(prdId);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}api/delete-wishlist`,
                {
                    user_id: userId,
                    item_id: prdId,
                }
            );
            if (res.data.message === "Wishlist item deleted successfully") {
                setWishItem((prev) => prev.filter((wishItm) => wishItm.item.id !== prdId));
                toast.success("Item removed from your wishlist.");
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            console.log("Delete Wishlist Item", error);
            toast.error(error?.response?.data?.message);
        } finally {
            setRemovingId(null);
        }
    };

    return (
        <div className="flex min-h-screen bg-gray-100 pt-[160px] pb-[50px]">
            <div className="w-64 bg-brandBlue shadow-lg py-8 px-4 text-white rounded-tr-[10px] rounded-br-[10px]">
                <h2 className="text-2xl font-bold mb-10">My Account</h2>
                <SideBar />
            </div>
            <div className="flex-1 p-10 pt-0 pb-0">
                <h2 className="text-4xl font-bold mb-7 text-brandBlue">My Wishlist</h2>
                {wishItem === null ? (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {[...Array(6)].map((_, index) => (
                            <Skeleton key={index} />
                        ))}
                    </div>
                ) : wishItem.length === 0 ? (
                    <div className="text-center py-20">
                        <div className="not_found_wrp">No item in Wishlist</div>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {wishItem.map((wishItm) => (
                            <Col key={wishItm.id} span={24}>
                                <div className="main-card border border-[#43AAD5] rounded-md p-5 bg-black">
                                    <button
                                        onClick={() => DeletWishItem(wishItm.item.id)}
                                        className="absolute top-6 right-5 border border-red-600 text-red-600 bg-red-600/10 hover:bg-red-600/20 font-semibold text-[10px] px-3 py-1 rounded-[5px] transition-all duration-200 shadow-sm">
                                        {removingId === wishItm.item.id ? 'Removing...' : 'Remove'}
                                    </button>

                                    <div className="main-custom-card justify-between flex flex-row">
                                        <h2 className="text-white font-syne text-2xl font-bold bg-[linear-gradient(60deg,_rgba(67,170,214,1)_80%,_rgba(0,0,1,1)_100%)] bg-clip-text text-transparent">
                                            {wishItm.item.name}
                                        </h2>
                                    </div>
                                    <div className="card-image flex items-center justify-center mt-5 overflow-hidden">
                                        <Link to={`/product/${wishItm.item.id}`}>
                                            <img
                                                className="w-full h-[230px] object-contain transition-transform duration-300 hover:scale-105"
                                                src={`${process.env.REACT_APP_SITE_IMAGES}${wishItm.item.photo}`}
                                                alt={wishItm.item.name}
                                            />
                                        </Link>
                                    </div>
                                    <div className="icons-part m-auto">
                                        <ul className="flex gap-2 items-center pt-5 justify-center">
                                            {wishItm.item.previous_price && (
                                                <li>
                                                    <span className="text-gray-400 line-through font-outfit text-[20px]">
                                                        ${wishItm.item.previous_price}
                                                    </span>
                                                </li>
                                            )}
                                            <li>
                                                <span className="text-white font-outfit text-[30px]">
                                                    ${wishItm.item.discount_price}
                                                </span>
                                            </li>
                                        </ul>
                                        <div className="flex justify-center items-center mt-5 mb-5 gap-3">
                                            <label className="cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name={`size-${wishItm.item.id}`}
                                                    className="peer hidden"
                                                />
                                                <div className="px-6 font-outfit py-2 rounded-full border border-white text-white font-medium peer-checked:bg-gradient-to-r peer-checked:from-[#43AAD6] peer-checked:to-black">
                                                    50ml
                                                </div>
                                            </label>
                                            <label className="cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name={`size-${wishItm.item.id}`}
                                                    className="peer hidden"
                                                />
                                                <div className="px-6 py-2 font-outfit rounded-full border border-white text-white font-medium peer-checked:bg-gradient-to-r peer-checked:from-[#43AAD6] peer-checked:to-black">
                                                    100ml
                                                </div>
                                            </label>
                                        </div>

                                        <Link
                                            to={`/product/${wishItm.item.id}`}
                                            className="font-syns text-[18px] rounded-full w-full flex items-center justify-center gap-2 text-white bg-[linear-gradient(90deg,_rgba(67,170,214,1)_0%,_rgba(0,0,0,1)_100%)] h-[50px] transition-all duration-300 hover:shadow-lg hover:scale-105"
                                        >
                                            Add To Cart
                                            <span>
                                                <HiOutlineShoppingBag />
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Wishlist;
